import { parse, unparse } from 'papaparse';
import { CSVParseError } from './errors';
export function parseCsvContentSync(fileContent, csvOptions) {
    const result = parse(fileContent, csvOptions);
    if (result.errors && result.errors.length > 0) {
        throw new CSVParseError(fileContent, result.errors);
    }
    else {
        return result.data;
    }
}
export function stringifyCsvData(data, config = {}) {
    return unparse(data, config);
}
